module.exports = __webpack_public_path__ + "img/portugal-logo-icon.e7bdff44.png";